/* istanbul ignore file */
// This component was removed from tests because it was not possible test tooltip and it was affecting the coverage of the tests. //

import { WindRoseSector } from "@/types/wind";
import Typography from "../../Typography";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import HeightDropdown from "../../Statistics/HeightDropdown";
import { WindScenario } from "../../../services/api";

if (typeof Highcharts === "object") {
  HighchartsMore(Highcharts);
}

type VariableSummary = {
  variableName: string; // "< 4m/s", "6-8m/s", "> 8m/s"
  color: string; // color based on value
};

type Props = {
  data: WindRoseSector[]; // 8 sectors: "N", "NE", "L", "SE", "S", "SO", "O", "NO"
  selectedHeight: string;
  selectedScenario: string;
  variablesSummary: VariableSummary[]; // 3 items: "< 4m/s", "6-8m/s", "> 8m/s"
  onHeightChange?: (height: string) => void;
  title?: string;
};

const WindRoseChart = ({
  title,
  variablesSummary,
  data,
  selectedHeight,
  onHeightChange,
}: Props) => {
  const options = {
    chart: {
      polar: true,
    },

    exporting: {
      enabled: false,
    },

    title: {
      text: title || "",
      style: {
        fontSize: "12px",
        color: "#0C2856",
      },
    },

    pane: {
      startAngle: 0,
      endAngle: 360,
      color: "#0C2856",
    },

    xAxis: {
      categories:
        variablesSummary.length > 0 ? data.map((d) => d.sectorName) : [],
      tickmarkPlacement: "on",
    },

    yAxis: {
      min: 0,
      endOnTick: false,
      showLastLabel: true,
      labels: {
        format: "{value}",
      },
      reversedStacks: false,
    },

    tooltip: {
      useHTML: true,
      formatter: function (this: Highcharts.TooltipFormatterContextObject) {
        const point = (this.point ??
          this) as Highcharts.TooltipFormatterContextObject["point"] & {
          variableName?: string;
        };
        return `
          <span style="color:${point.color || "#ccc"};">●</span> ${
          point.variableName || "N/A"
        }: <strong>${point.y?.toFixed(1) ?? "N/A"}%</strong>
        `;
      },
    },

    plotOptions: {
      series: {
        stacking: "normal",
        shadow: false,
        groupPadding: 0,
        pointPlacement: "on",
      },
    },

    // Create a series for each item (eg: Velocidade mínima, média, máxima)
    series: variablesSummary.map((variable) => ({
      type: "column",
      name: variable.variableName,
      data: data?.map((sector) => {
        const variableData = sector.data.find(
          (d) => d.variableName === variable.variableName
        );
        return {
          name: sector.sectorName,
          y: variableData?.y ?? 0,
          value: variableData?.value ?? 0,
          color: variable?.color ?? "#ccc",
          variableName: variable.variableName,
        };
      }),
      color: variable.color,
    })),

    credits: {
      enabled: false,
    },
  };

  {
    return data.length > 0 ? (
      <div className="flex flex-col relative pb-4 bg-white rounded-lg shadow-md">
        {onHeightChange && (
          <div className="absolute top-0 right-0 z-10">
            <HeightDropdown
              windHeight={selectedHeight}
              setWindHeight={onHeightChange}
            />
          </div>
        )}
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    ) : (
      <Typography variant="body2" className="text-[#666] text-center">
        Nenhum dado disponível
      </Typography>
    );
  }
};

export default WindRoseChart;
